import { DOCUMENT } from '@angular/core';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { WINDOW } from '@core/constants/window-token';

@Injectable({ providedIn: 'root' })
export class ChatbotService {
  private nif: string | null = null;
  private initialized: boolean = false;
  private eventListener: ((event: any) => void) | null = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private windowRef: Window,
  ) {}

  public loadScript(scriptId = 'chatbotScript', userId = null) {
    return new Promise((resolve, reject) => {
      this.nif = userId;

      // Si ya está inicializado, resolvemos
      if (this.initialized) {
        this.updateNif(this.nif);
        resolve({ id: scriptId, loaded: true, status: 'Already Loaded', nif: userId });
        return;
      }

      // Registramos el listener lo primero para setar variable prechat
      this.eventListener = () => {
        try {
          (this.windowRef as any).embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
            ContextNIFFromWeb: this.nif,
          });
        } catch (error) {
          console.error('Error prechat: ', error);
        }
      };
      this.windowRef.addEventListener('onEmbeddedMessagingReady', this.eventListener);

      // Cargamos el sdk si no existe
      if (!this.document.getElementById(scriptId)) {
        const sdkChatbot = this.document.createElement('script');
        sdkChatbot.type = 'text/javascript';
        sdkChatbot.id = scriptId;
        sdkChatbot.src = environment.chatbot.sdkURL;
        sdkChatbot.async = true;

        sdkChatbot.onload = () => {
          this.initEmbeddedMessaging();
          this.initialized = true;
          resolve({ id: scriptId, loaded: true, status: 'Chatbot inicializado', nif: this.nif });
        };

        sdkChatbot.onerror = () => {
          console.error('Error cargando el SDK Salesforce');
          reject({
            id: scriptId,
            loaded: false,
            status: 'Error',
            error: 'Error cargando el SDK Salesforce',
            nif: this.nif,
          });
        };

        this.document.body.appendChild(sdkChatbot);
      } else {
        this.initEmbeddedMessaging();
        this.initialized = true;
        resolve({ id: scriptId, loaded: true, status: 'Chatbot inicializado', nif: this.nif });
      }
    });
  }

  private initEmbeddedMessaging() {
    try {
      const bootstrap = (this.windowRef as any).embeddedservice_bootstrap;
      // Configuración previa
      bootstrap.settings.language = 'es';
      // Inicializar widget
      bootstrap.init(
        environment.chatbot.orgIdSF,
        environment.chatbot.typeChat,
        environment.chatbot.siteURL,
        { scrt2URL: environment.chatbot.scrt2URL },
      );
    } catch (error) {
      console.error('Error inicializando Embedded Messaging -> ', error);
    }
  }

  public removeScript(): void {
    const script = this.document.getElementById('chatbotScript');
    if (script) script.remove();

    if (this.eventListener) {
      this.document.removeEventListener('onEmbeddedMessagingReady', this.eventListener);
      this.eventListener = null;
    }
    this.initialized = false;
  }

  public updateNif(newNif: string | null): void {
    this.nif = newNif;
    try {
      const bootstrap = (this.windowRef as any).embeddedservice_bootstrap;
      bootstrap?.prechatAPI?.setHiddenPrechatFields({ ContextNIFFromWeb: this.nif });
    } catch (error) {
      console.error('Error actualizando NIF:', error);
    }
  }
}
